import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import { PinIcon } from '@adsk/alloy-react-icon';
import { addressItem, geocoderItemAddress, geocoderItemIcon } from './styles';
var AutocompleteAddressItem = function AutocompleteAddressItem(_ref) {
  var address = _ref.address;
  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(PinIcon, {
    style: geocoderItemIcon
  }), /*#__PURE__*/React.createElement(_StyledSpan, null, address));
};
AutocompleteAddressItem.propTypes = {
  address: PropTypes.string.isRequired
};
export default AutocompleteAddressItem;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), addressItem);
var _StyledSpan = _styled2("span").withConfig({
  displayName: "component___StyledSpan",
  componentId: "sc-voccfx-0"
})(["", ""], geocoderItemAddress);
//# sourceMappingURL=component.js.map